export default __webpack_public_path__ + "static/media/logo-yh.bb7aae68.png";